import type { HelpSection } from 'components/network-graph/core/controls/graph-help-button'
import styles from '../core/controls/graph-help-button.module.scss'

export const viewCaseHelpSections: HelpSection[] = [
  {
    key: 'overview',
    label: 'Overview',
    children: (
      <p>
        The Network Graph shows how entities in this case are connected. Explore relationships between businesses,
        accounts, contact information, and identities at a glance.
      </p>
    ),
  },
  {
    key: 'entity-types',
    label: 'Entity Types',
    children: (
      <ul className={styles.helpList}>
        <li>
          <strong>Data Sources</strong> — Online accounts and platforms
        </li>
        <li>
          <strong>Contact Info</strong> — Phone numbers, email addresses, and locations
        </li>
        <li>
          <strong>Identities</strong> — People or entities that group related data together (square shape with photo)
        </li>
        <li>Each entity is represented by a node in the graph.</li>
      </ul>
    ),
  },
  {
    key: 'edges',
    label: 'Edges & Relationships',
    children: (
      <p>
        Edges between entities show how entities are connected. A short description on each edge explains the reason for
        the connection.
      </p>
    ),
  },
  {
    key: 'evidence-layers',
    label: 'Evidence Layers',
    children: (
      <>
        <p>Use the toggles to show or hide contact information:</p>
        <ul className={styles.helpList}>
          <li>
            <strong>Phones</strong> — Display phone numbers connected to entities
          </li>
          <li>
            <strong>Emails</strong> — Display email addresses connected to entities
          </li>
          <li>
            <strong>Addresses</strong> — Display physical locations connected to entities
          </li>
        </ul>
      </>
    ),
  },
  {
    key: 'navigation',
    label: 'Navigation',
    children: (
      <ul className={styles.helpList}>
        <li>
          <strong>Zoom</strong> — Scroll or use +/- buttons to zoom in and out
        </li>
        <li>
          <strong>Pan</strong> — Click and drag to move around the graph
        </li>
        <li>
          <strong>Search</strong> — Type a name or ID to find and focus on a specific entity
        </li>
        <li>
          <strong>Focus</strong> — Click any entity to highlight it and view its details
        </li>
      </ul>
    ),
  },
]
